import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DeliveryAuthService } from '../services/delivery-auth.service';

export const deliveryGuard: CanActivateFn = () => {
  const auth = inject(DeliveryAuthService);
  const router = inject(Router);
  auth.pruneInvalidSession();
  if (auth.isLoggedIn()) return true;
  return router.createUrlTree(['/delivery/login']);
};

export const deliveryGuestGuard: CanActivateFn = () => {
  const auth = inject(DeliveryAuthService);
  const router = inject(Router);
  auth.pruneInvalidSession();
  if (!auth.isLoggedIn()) return true;
  return router.createUrlTree(['/delivery/dashboard']);
};
